
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/fr'
import Swiper from 'swiper';

import Axios from 'axios';
import bsCustomFileInput from 'bs-custom-file-input'
require('trumbowyg/dist/trumbowyg.min.js');
import 'trumbowyg/dist/ui/trumbowyg.min.css';

Vue.use(ElementUI, { locale })

window.data_get = (target, path, fallback) => {
    let segments = Array.isArray(path) ? path : path.split('.');
	let [segment] = segments;

	let find = target;

	if (segment !== '*' && segments.length > 0) {
		if (find[segment] === null || typeof find[segment] === 'undefined') {
			find = typeof fallback === 'function' ? fallback() : fallback;
		}
		else {
			find = data_get(find[segment], segments.slice(1), fallback);
		}
	}

	else if (segment === '*') {
		const partial = segments.slice(path.indexOf('*') + 1, path.length);

		if (typeof find === 'object') {
			find = Object.keys(find).reduce((build, property) => ({
					...build,
					[property]: data_get(find[property], partial, fallback)
				}),
			{});
		}
		else {
			find = data_get(find, partial, fallback);
		}
	}
	if (typeof find === 'object') {
		if (Object.keys(find).length > 0) {
			const isArrayTransformable = Object.keys(find).every(index => index.match(/^(0|[1-9][0-9]*)$/));

			return isArrayTransformable ? Object.values(find) : find;
		}
	} else {
		return find;
	}
}



/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('user-group-component', require('./components/UserGroupComponent.vue').default);
Vue.component('calculateur', require('./components/Calculateur.vue').default);
Vue.component('select-component', require('./components/SelectComponent.vue').default);
Vue.component('user-select-component', require('./components/UserSelectComponent.vue').default);
Vue.component('ingredient-seasons', require('./components/IngredientSeasons.vue').default);
Vue.component('duel-tip-editor', require('./components/DuelTipEditor.vue').default);
Vue.component('schedules-editor', require('./components/SchedulesEditor.vue').default);
Vue.component('export-recipe-warning', require('./components/ExportRecipeWarning').default);
Vue.component('ingredient-measure-units', require('./components/IngredientMeasureUnits').default);

Vue.component('share-recipe-warning', require('./components/ShareRecipeWarning').default);
Vue.component('widget-newsletter', require('./components/WidgetNewsletter').default);
Vue.component('link-modal-pro', require('./components/LinkModalPro').default);
Vue.component('admin-transform-recipe', require('./components/AdminTransformRecipe').default);
Vue.component('upload-images', require('./components/UploadImages').default);

Vue.component('dashboard-recipes', require('./components/Recipes/Dashboard').default);
Vue.component('recipe-change-owner', require('./components/RecipeChangeOwner').default);
Vue.component('bulk-recipes-change-owner', require('./components/BulkRecipesChangeOwner').default);
Vue.component('bulk-user-change-role', require('./components/BulkUserChangeRole').default);
Vue.component('fields-restricted-manager', require('./components/FieldsRestrictedManager').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app'
});


$(document).ready(function(){

    var changeLanguageSelection = function( form, value ){
        form.find('.form-lang').each(function(){
            $(this).addClass('hidden');
        });
        form.find('.form-lang[data-lang="' + value + '"]').removeClass('hidden');
    };

    $(document).on('change', '.field-selector-lang', function(e){
        var self = $(e.currentTarget)
        if( self.data('form') ) {
            var form = $(self.data('form'))
        } else {
            var form = $(e.currentTarget).parents('form')
        }
        changeLanguageSelection(form, self.val());
    });

    $(".call-tooltip").tooltip();

    $(document).on('click', '.btn-set-public', function(e){
        var self = $(e.currentTarget)
        var recipesInput = $('input[name="recipes[]"]:checked')
        var recipes = Array.from(recipesInput).map( v => v.value );
        if( recipes.length && confirm('Publier les recettes séléctionné ?') ) {
            axios.post('/pro/recipes/publish', {recipes: recipes}).then(()=>{
                window.location.reload()
            })
        }
    });

    $(document).on('click', '.btn-set-calcul', function(e){
        var self = $(e.currentTarget)
        var recipesInput = $('input[name="recipes[]"]:checked')
        var recipes = Array.from(recipesInput).map( v => v.value );
        if( recipes.length && confirm('Calculer les recettes séléctionné ?') ) {
            axios.post('/pro/recipes/calcul', {recipes: recipes}).then(()=>{
                window.location.reload()
            })
        }
    });

    $(document).on('change', 'input[name="recipes[]"]', function(e){
        var recipesInput = $('input[name="recipes[]"]:checked')
        var recipes = Array.from(recipesInput).map( v => v.value ).join(',');
        $('input[name=recipes_selected]').val(recipes)
    });

    $(document).on('change', 'input[name="ingredients[]"]', function(e){
        var ingredientsInput = $('input[name="ingredients[]"]:checked')
        var ingredients = Array.from(ingredientsInput).map( v => v.value ).join(',');
        $('input[name=ingredients_selected]').val(ingredients)
    });

    $(document).on('change', 'input[name="users[]"]', function(e){
        var usersInput = $('input[name="users[]"]:checked')
        var users = Array.from(usersInput).map( v => v.value ).join(',');
        $('input[name=users_selected]').val(users)
    });

    const updateTipTypeStatus = function(value) {
        if (parseInt(value) === 0) {
            $('#tip-type-tip').show();
            $('#tip-type-duel').hide();
        } else {
            $('#tip-type-tip').hide();
            $('#tip-type-duel').show();
        }
    };

    $('#tip-type-select input').change(function(e) {
        updateTipTypeStatus(e.target.value);
    });

    if ($('#tip-type-select').length) {
        updateTipTypeStatus($('#tip-type-select input:checked').val());
    }

    $.trumbowyg.svgPath = '/images/icons.svg';
    $('.html-editor').trumbowyg();

    bsCustomFileInput.init()

    const keyStorageExport = 'choice-export'
    var choiceExportChecked =  window.localStorage.getItem(keyStorageExport);

    if( choiceExportChecked ) {
        var checked = JSON.parse(choiceExportChecked);

        Array.from(document.querySelectorAll('.choice-export input[type=checkbox]')).forEach(v => {
            if( checked.indexOf(v.value) != -1 ) {
                v.checked = true
            } else {
                v.checked = false
            }
        })

    }


    $(document).on('change', '.choice-export input[type=checkbox]', (e)=>{
        var checked = Array.from(document.querySelectorAll('.choice-export input[type=checkbox]:checked'))
        checked = checked.map((v)=>v.value)
        window.localStorage.setItem(keyStorageExport, JSON.stringify(checked));
        axios.post('user/settings', {'recipeDisplay':checked}).then(function(r){
        })
    });


    $(document).on('click', 'input[name="allRecipes"]', function(e){
        let self = e.currentTarget;
        $('input[name="recipes[]"]').each((i, elm)=>{
            elm.checked = self.checked
            $(elm).change()
        });
    });

    $(document).on('click', 'input[name="allItems"]', function(e){
        let self = e.currentTarget;
        $('input[name="items[]"]').each((i, elm)=>{
            elm.checked = self.checked
            $(elm).change()
        });
    });

    $(document).on('change', 'input[name="items[]"]', function(e){
        var recipesInput = $('input[name="items[]"]:checked')
        var recipes = Array.from(recipesInput).map( v => v.value ).join(',');
        $('input[name=items_selected]').val(recipes)
    });

    $(document).on('click', 'input[name="allUsers"]', function(e){
        let self = e.currentTarget;
        $('input[name="users[]"]').each((i, elm)=>{
            elm.checked = self.checked
            $(elm).change()
        });
    });

    $(document).on('click', '.btn-approuve', function(e){
        e.preventDefault();
        var users = $('input[name=users_selected]').val();
        if( users ) {
            $('#formApprouve').submit();
        }
    });

    $(document).on('click', '.opentriangle', function(e){
        e.preventDefault();
        let self = $(this);
        let show = self.data('show');
        let tab = $('.infos-tableau');
        tab.addClass('hide');
        tab.find('.inf').addClass('hide');
        let isActive = self.hasClass('active');
        $('.opentriangle').removeClass('active');
        if( !isActive ) {
            self.addClass('active')
            tab.find('.'+show).removeClass('hide')
            tab.removeClass('hide')
        }
    });

    $(document).on('click', '.infos-tableau .close-info', function(e){
        e.preventDefault();
        let self = $(this);
        let show = self.data('show');
        let tab = $('.infos-tableau');
        tab.addClass('hide');
        tab.find('.inf').addClass('hide');
        let isActive = self.hasClass('active');
        $('.opentriangle').removeClass('active');
    });

    let checkExists = async function(route, fields) {
        let ctn = $('.invalid-feedback');
        let alertZone = ctn.find('.alert');
        ctn.hide()
        let id = getCurrentIdForCheckExists();
        if(id) {
            fields.id = id;
        }
        let response = await axios.post(route, fields);
        let data = response.data;
        if( data.exists.length ) {
            ctn.show();
            data.exists.forEach((v)=>{
                alertZone.append(v.message)
            })
        }
    }

    let getCurrentIdForCheckExists = function() {
        let id = $('[name=id]').val();
        if( id ) {
            return id;
        }
        return null;
    }

    let geocodingAddressIsRunning = false;

    let geocodingAddress = async function(address) {
        // prevent overlaping request
        if( geocodingAddressIsRunning ) {
            return null;
        }
        geocodingAddressIsRunning = true;
        let url = 'https://nominatim.openstreetmap.org/search/?format=geocodejson&q='+address;
        let response = await fetch(url);
        let data = await response.json();
        if( data.features.length ) {
            let feature = data.features[0];
            let lat = feature.geometry.coordinates[1];
            let lng = feature.geometry.coordinates[0];
            geocodingAddressIsRunning = false;
            return {lat, lng};
        }
        geocodingAddressIsRunning = false;
        return null;
    }

    $(document).on('change', '.nameRestaurant, .nameProducer', async function(e){
        let value = $(this).val();
        if(!value) return;
        let route = '/app/restaurants/checkExists';
        if(this.classList.contains('nameProducer')) {
            route = '/app/producers/checkExists';
        }
        await checkExists(route,{name: value});
    });

    $(document).on('change', '.addressRestaurant, .addressProducer', async function(e){
        let value = $(this).val();
        if(!value) return;
        let route = '/app/restaurants/checkExists';
        if(this.classList.contains('addressProducer')) {
            route = '/app/producers/checkExists';
        }
        let inputs = ['address', 'post_code', 'city'];
        let fields = {};
        inputs.forEach((v)=>{
            let val = $('[name="'+v+'"]').val();
            if( val ) {
                fields[v] = val;
            }
        })
        if( Object.keys(fields).length !== inputs.length ) return;
        await checkExists(route, {
            fulladress: fields.address + ' ' + fields.post_code + ' ' + fields.city
        });

        let finded = await geocodingAddress(fields.address + ' ' + fields.post_code + ' ' + fields.city);
        if(finded) {
            $('[name=longitude]').val(finded.lng);
            $('[name=latitude]').val(finded.lat);
        }
    });

    $(document).on('click', '.toggleInfos', function(e){
        e.preventDefault();
        $('.infos-app').toggleClass('hidden');
        $('.toggleInfos .fe-plus-circle, .toggleInfos .fe-minus-circle').toggleClass('hidden');
    });

    $(document).on('click', '.toggleBodyCard', function(e){
        e.preventDefault();
        $(this).parents('.card').find('.toHide').toggleClass('hidden');
        $('.toggleInfos .fe-plus-circle, .toggleInfos .fe-minus-circle').toggleClass('hidden');
    });

    $(document).on('click', '#data-environnement-show-more', function(e){
        e.preventDefault();
        $('.data-environnement').toggleClass('hidden');
        $('#data-environnement-show-more span').toggleClass('hidden');
    });

    $(document).on('click', '#data-nutrition-show-more', function(e){
        e.preventDefault();
        $('.data-nutrition').toggleClass('hidden');
        $('#data-nutrition-show-more span').toggleClass('hidden');
    });


    $(document).on('click', '#open-close-menu-mobile', function(e){
        console.log('click menu')
        $(this).toggleClass('open')
        $('#navbarSupportedContent').toggleClass('open')
    });


    /* Init Swiper : related data  */
    var init = false;
    var swiper;
    function relatedSwiper() {
        if (window.innerWidth <= 991) {
            if (!init) {
            init = true;
            swiper = new Swiper(".related-swiper", {
                    slidesPerView: 2.4,
                    spaceBetween: 15,
                    loop: true,
                });
            }
        } else if (init) {
            swiper.destroy();
            init = false;
        }
    }
    relatedSwiper();
    window.addEventListener("resize", relatedSwiper);
    /* End Swiper  */

    /* Init Swiper : partrners data  */
    if($(".partrners-swiper").length){
        function partrnersSwiper() {
            swiper = new Swiper(".partrners-swiper", {
                slidesPerView: 1,
                spaceBetween: 100,
                loop: false,
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                  992: {
                    slidesPerView: 2,
                    spaceBetween: 100,
                  },
                },
            });
        }
        partrnersSwiper();
    }
    /* End Swiper  */



    /* Init LoadMore  */
    var nextPageLink = $('.next-page a').attr('href');
    if(!nextPageLink){
        $('#pagination-loadmore').remove();
    }
    function loadNextPage() {
        if (nextPageLink) {
            $.ajax({
                url: nextPageLink,
                type: 'GET',
                dataType: 'html',
                success: function(data) {
                    var $data = $(data);
                    var $newContent = $data.find('.result .related'); // Remplacez '#content' par le sélecteur de votre contenu
                    $('.result .related').append($newContent.html());
                    nextPageLink = $data.find('.next-page a').attr('href'); // Remplacez '#nextPageLink' par le sélecteur du lien de la page suivante
                    $('#pagination-loadmore').css('opacity', '1');
                }
            });
        }else{
            $('#pagination-loadmore').remove();
        }
    }
    $('#pagination-loadmore').on('click', function() {
        $('#pagination-loadmore').css('opacity', '0.8');
        loadNextPage();
    });
    /* End LoadMore  */


    let videoOverlays = document.querySelectorAll('.et_pb_video_overlay');
    if(videoOverlays.length) {
        videoOverlays.forEach(videoOverlay => {
            videoOverlay.addEventListener('click', function(e){
                e.preventDefault();
                let video = document.querySelector('#' + this.dataset.video);
                video.play();
                videoOverlay.style.display = 'none';
            })
        })

    }

});
